import { atom } from 'recoil';

/**
 * グローバルアラートダイアログの表示状態を管理する型
 * メンテナンス・システムエラーなど、画面全体に影響するエラーダイアログに使用する。
 * alertStateとは異なり、クローズ時のアクションやHTML表示などの柔軟なカスタマイズが可能。
 */
type AlertGlobal = {
  /** ダイアログの表示状態 */
  isOpen: boolean;
  /** ダイアログに表示するメッセージ */
  message: string;
  /** アラートの種別（空文字の場合は汎用エラー） */
  type: string;
  /** trueの場合はHTML形式でメッセージを表示する */
  isInnerHtmlLayout?: boolean;
  /** ダイアログを閉じた際に実行されるコールバック（画面遷移など） */
  closeAction: VoidFunction;
};

/**
 * グローバルアラートダイアログのステート
 * アプリケーション全体で共有されるエラーダイアログの表示制御に使用する。
 */
const alertGlobalState = atom<AlertGlobal>({
  key: 'alertGlobal',
  default: {
    isOpen: false,
    message: '',
    type: '',
    isInnerHtmlLayout: false,
    closeAction: () => {},
  },
});

export default alertGlobalState;
